import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { CartService } from '../../appshared/invoice/cart.service';
import { ViewItem } from '../../appshared/invoice/item/item.module';
import { FooterComponent } from '../../shared/footer/footer.component';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { LocalStoreService } from '../../services/local-store.service';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    CommonModule,
    RouterLink,
    TranslateModule,
  ],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.css',
})
export class CartComponent implements OnInit {
  cartItems: ViewItem[] = [];
  totalAmount: number = 0;
  public apiURL: string = '';
  currentLang = localStorage.getItem('locale') || 'en';
  dir = this.currentLang === 'ar' ? 'rtl' : 'ltr';

  constructor(
    private cartService: CartService,
    private ls: LocalStoreService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    const savedItems = this.ls.getItem('CartItems');
    if (savedItems) {
      this.cartService.setItemsData(savedItems);
    }

    this.loadCartItems();
    this.calculateTotal();

    this.cartService.ordersChanged.subscribe(() => {
      this.loadCartItems();
      this.calculateTotal();
    });

    this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + 1 + '/Items/';
    console.log(this.currentLang);
  }
  loadCartItems(): void {
    this.cartItems = this.cartService.getItems();
  }

  calculateTotal(): void {
    this.totalAmount = this.cartItems.reduce((total, item) => {
      return total + item.salesPrice! * item.cartQuantity;
    }, 0);
  }

  increaseQuantity(itemId: number): void {
    this.cartService.incQtyNumber(itemId);
    this.calculateTotal();
  }

  decreaseQuantity(itemId: number): void {
    this.cartService.decQtyNumber(itemId);
    this.calculateTotal();
  }

  removeItem(itemId: number): void {
    this.cartService.deleteFromCart(itemId);
    this.calculateTotal();
  }
}
